export default __webpack_public_path__ + "static/media/crowns.8b0be7d8.svg";